import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useSeo } from "@/lib/useSeo";

export default function NotFoundPage() {
  useSeo("Page Not Found", "Lost in the Woods");
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-20" data-testid="not-found-page">
      <div className="text-center max-w-lg">
        <div className="w-20 h-20 rounded-full bg-cozy-pink mx-auto flex items-center justify-center mb-6 shadow-cozy">
          <Sparkles className="w-9 h-9 text-cozy-gold" />
        </div>
        <h1 className="font-serif text-6xl text-cozy-brown">
          <span className="font-script text-cozy-gold">Oops…</span>
        </h1>
        <p className="font-serif text-2xl mt-3">Lost in the woods?</p>
        <p className="text-cozy-brown-soft mt-4 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let's get you back to something magical.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mt-8">
          <Link to="/" className="px-7 py-3.5 rounded-full bg-cozy-gold text-white hover:bg-cozy-gold-dark transition shadow-cozy" data-testid="404-home">
            Back to Home
          </Link>
          <Link to="/booking" className="px-7 py-3.5 rounded-full bg-white border border-cozy-gold/30 text-cozy-brown hover:bg-cozy-beige transition shadow-cozy" data-testid="404-book">
            Book a Party
          </Link>
        </div>
      </div>
    </div>
  );
}
